import { render, staticRenderFns } from "./HeaderLogoText.vue?vue&type=template&id=569407c4&"
import script from "./HeaderLogoText.vue?vue&type=script&lang=js&"
export * from "./HeaderLogoText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports